// extracted by mini-css-extract-plugin
module.exports = {"loader":"BranchList_loader__2n6na","add":"BranchList_add__1C58x"};